import {DebugSheetFragment, SheetFragment, SheetRows} from "fe-common/graphql/index";

// type SheetFragment = any;
// type SheetRows = any;

type GridRange = gapi.client.sheets.GridRange;
type UpdateValuesResponse = gapi.client.sheets.UpdateValuesResponse
type BatchUpdateValuesResponse = gapi.client.sheets.BatchUpdateValuesResponse
export function addSpreadsheetToGapiClient() {
  setTimeout(() => {
    //So gapi will be init eagerly
    // @ts-ignore
    let gapiClient = window.gapi;

    gapiClient?.load("client:auth2", initClient);
    function initClient() {
      // console.log("Initiated!");

      // Array of API discovery doc URLs for APIs used by the quickstart
      var DISCOVERY_DOCS = [
        "https://sheets.googleapis.com/$discovery/rest?version=v4",
      ];

      // Authorization scopes required by the API; multiple scopes can be
      // included, separated by spaces.
      var SCOPES = "https://www.googleapis.com/auth/spreadsheets";

      try {
        gapiClient.client
          .init({
            clientId:
              "317298733069-i63k1fug1tjfgb1g7i6ht9hpfen4oiqf.apps.googleusercontent.com",
            discoveryDocs: DISCOVERY_DOCS,
            scope: SCOPES,
          })
          .then(
            function() {},
            (err) => {
              console.log("failed to start gapi", err);
            },
          );
      } catch (e) {
        console.log("Failed to start gapi", e);
      }
    }
  }, 500);
}

const debugInfoToPlainMatrix = (debugInfo: SheetFragment): string[][] =>
  debugInfo.rows.map((row) => row.cols);

export const exportDebugSheets = async (
  sheets: DebugSheetFragment[],
  caseDescription: string,
  onBeforeNav?: () => void,
) => {
  let gapiClient = getGapi();
  // this.setState({ loadstate: DDLoadState.REQUESTED });
  // const debugInfoMatrix = debugInfoToPlainMatrix(debugInfo);
  //creating empty sheet
  try {
    let createRes;

      const spreadsheetBody = createEmptySpreadSheetRequest((caseDescription || "Case") + " Debug Info", sheets.map(s => s.name))
      createRes = await gapiClient.client.sheets.spreadsheets.create({}, spreadsheetBody,);

      const newSpreadsheetID = createRes.result.spreadsheetId;
      const { sheetId, gridProperties } = createRes.result.sheets[0].properties
    const sheetIDs = createRes.result.sheets.map(sheet => sheet.properties.sheetId)
    //fill sheet with values
      const params = {
        spreadsheetId: newSpreadsheetID,
      };
      const data = sheets.map(sheet => ({
        majorDimension: "ROWS",
        values: debugInfoToPlainMatrix(sheet.sheet),
        range:sheet.name
      }));

      let valueUpdatesRes  : BatchUpdateValuesResponse = (await gapiClient.client.sheets.spreadsheets.values.batchUpdate(
        params,
          { data, valueInputOption: "USER_ENTERED" },
      )).result;

      const sheetRanges : GridRange[] = valueUpdatesRes.responses.map((res,i) => ({
        "sheetId": sheetIDs[i],
        "startRowIndex": 0,
        "endRowIndex":  res.updatedRows || 1000 + 1,
        "startColumnIndex": 0,
        "endColumnIndex": res.updatedColumns || 100 + 1,
      }))


    //add conditional formatting for sheet
    await gapiClient.client.sheets.spreadsheets.batchUpdate({spreadsheetId: newSpreadsheetID},{
        requests: sheetRanges.flatMap(sheetRange => [
          makeBoolenConditionalFormatRuleRequest("Low+",sheetRange,"#d9ead3"),
          makeBoolenConditionalFormatRuleRequest("Med+",sheetRange,"#b6d7a8"),
          makeBoolenConditionalFormatRuleRequest("High+",sheetRange,"#93c47d"),
          makeBoolenConditionalFormatRuleRequest("Low-",sheetRange,"#e6b8af"),
          makeBoolenConditionalFormatRuleRequest("Med-",sheetRange,"#ee9a8b"),
          makeBoolenConditionalFormatRuleRequest("High-",sheetRange,"#e35454"),
        ])
      })

      console.log(newSpreadsheetID);

      onBeforeNav && onBeforeNav();
      window.open(
        "https://docs.google.com/spreadsheets/d/" + newSpreadsheetID + "/edit",
        "_blank",
      );
      // this.state.googleError = null;

  } catch (e) {
    // this.state.googleError = JSON.stringify(e);
    console.log(`spreadsheet error ${e}`);
    throw e;
  }

  // this.setState({ loadstate: DDLoadState.AVAILABLE });
};
export function mergeSheetsRows(
  sheetsToConcat: SheetFragment[],
): SheetFragment {
  const emptyRow: SheetRows = { cols: [" "] };
  return {
    rows: sheetsToConcat.filter((x) => x).flatMap((sheet) => sheet.rows),
  };
}
export function getGapi() {
  // @ts-ignore
  return window.gapi;
}

const makeBoolenConditionalFormatRuleRequest   =  (textContains, range : GridRange, rgb:string) => ({
  "addConditionalFormatRule": {
    "rule": {
      "ranges": [ range ],
      "booleanRule": {
        "condition": {
          "type": "TEXT_CONTAINS",
          "values": [ { "userEnteredValue": textContains } ]
        },
        "format": {
          "backgroundColor": rgbHexToFractions(rgb)
        }
      }
    },
    "index": 0
  }
} as gapi.client.sheets.Request )

const rgbHexToFractions = (rgb:string) => {
  //Assumption - rgb consist of 6 hex characters.
  rgb = rgb.replace("#", "")
  return {
    red: parseInt(rgb.slice(0, 2), 16) / 255,
    green: parseInt(rgb.slice(2, 4), 16) / 255,
    blue: parseInt(rgb.slice(4, 6), 16) / 255
  }
}
const createEmptySpreadSheetRequest = (title:string, sheetNames: string[]) => ({
  properties: {
    title
  },
  sheets: sheetNames.map(sheetName => (
    {
      properties: {
        title: sheetName,
      },
    }))
})
